'use client'

import { useState } from 'react'
import { trackPostHogEvent } from '@/lib/utils/dataLayer'
import { ZOHO_AUDIT_OFFER } from '@/lib/zoho-rescue-data'

export default function ZohoAuditBuyButton({
  className,
  location,
}: {
  className?: string
  location: string
}) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function startCheckout() {
    if (loading) return
    setError(null)
    setLoading(true)

    trackPostHogEvent('cta_click', {
      cta_text: ZOHO_AUDIT_OFFER.cta,
      cta_location: location,
      cta_type: 'primary',
      plan: ZOHO_AUDIT_OFFER.id,
    })

    try {
      const res = await fetch('/api/services/book', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product: ZOHO_AUDIT_OFFER.productId }),
      })
      const data = await res.json()

      if (!res.ok || !data.url) {
        setError(data.error || 'Could not start checkout. Please try again.')
        setLoading(false)
        return
      }

      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'ph_checkout_started',
          serviceName: ZOHO_AUDIT_OFFER.name,
          serviceSlug: ZOHO_AUDIT_OFFER.slug,
          totalPrice: ZOHO_AUDIT_OFFER.price,
        })
      }

      window.location.href = data.url
    } catch {
      setError('Network error. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className="inline-flex flex-col items-center gap-2">
      <button
        type="button"
        disabled={loading}
        onClick={startCheckout}
        className={className}
      >
        {loading ? 'Redirecting…' : ZOHO_AUDIT_OFFER.cta}
      </button>
      {error ? <p className="max-w-xs text-center text-[13px] text-red-600">{error}</p> : null}
    </div>
  )
}
